import React, { useState,useEffect } from "react";
import '../components/css/SideBar.css'
import { CircleX,ChevronRight, HomeIcon,User,NotebookPen,CalendarClock, CircleCheckBig, NotepadText, Landmark, ChartNoAxesCombined, Megaphone, FileUser, Download, Club } from "lucide-react";
import { useNavigate,useLocation } from "react-router-dom";
import InstallPopup from "../InstallButton";



const SideBar = ({setSideBar,show_sidebar,})=>{
     const navigate = useNavigate();
 
    
      const location = useLocation();
      const [active_menu,setActiveMenu] = useState();
      const MenuClick =   (active)=>{
            navigate('/student/'+active);
            setSideBar(false);
            // setActiveMenu(active);
             
        } 
 
       useEffect(()=>{
              let pathname = location.pathname;

setActiveMenu(pathname.replace("/student/", ""))
      },[location])

       const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [dontShow, setDontShow] = useState(false);
         useEffect(() => {
 
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
       
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);
 

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    closePopup();
  };

  const closePopup = () => {
    if (dontShow) {
      localStorage.setItem("hideInstallPopup", "true");
    }
    setVisible(false);
  };
    return(<>
     <div className={`SideBar ${show_sidebar ? 'open' : 'close'}`}>
        <div className="drawer-title">
            Menues <CircleX onClick={()=>setSideBar(false)}/>
        </div>         <div className="drawer-menues" style={{maxHeight: 'calc(100vh - 80px)', overflowY: 'auto'}}>

             
            <div className={`drawer-menu-item  ${active_menu === 'dashboard' ? 'sidebar-active-menu' : ''}`} onClick={()=>MenuClick('dashboard')}>
                <div className="menu-item-super">
                    <HomeIcon/> Home  
                </div> 
                
                  <ChevronRight/> 
                
            </div>
            
            <div className={`drawer-menu-item  ${active_menu === 'homework' ? 'sidebar-active-menu' : ''}`} onClick={()=>MenuClick('homework')}>
                <div className="menu-item-super">
                    <NotebookPen/> Assignements
                </div> 
                
                  <ChevronRight/> 
                
            </div>
        
            <div className={`drawer-menu-item  ${active_menu === 'attendance' ? 'sidebar-active-menu' : ''}`} onClick={()=>MenuClick('attendance')}>
                <div className="menu-item-super">
                    <CalendarClock/> Attendance
                </div> 
                
                  <ChevronRight/> 
                
            </div>
              <div className={`drawer-menu-item  ${active_menu === 'quiz' ? 'sidebar-active-menu' : ''}`} onClick={()=>MenuClick('quiz')}>
                <div className="menu-item-super">
                    <CircleCheckBig/> MCQs Test
                </div> 
                
                  <ChevronRight/> 
                
            </div>
            <div className={`drawer-menu-item  ${active_menu === 'class-test' ? 'sidebar-active-menu' : ''}`} onClick={()=>MenuClick('class-test')}>
                <div className="menu-item-super">
                    <NotepadText/> Class Test
                </div> 
                
                  <ChevronRight/> 
                
            </div>
            <div className={`drawer-menu-item  ${active_menu === 'fee' ? 'sidebar-active-menu' : ''}`} onClick={()=>MenuClick('fee')}>
                <div className="menu-item-super">
                    <Landmark/> School Fee
                </div> 
                
                  <ChevronRight/> 
                
            </div>
            <div className={`drawer-menu-item  ${active_menu === 'result' ? 'sidebar-active-menu' : ''}`} onClick={()=>MenuClick('result')}>
                <div className="menu-item-super">
                    <ChartNoAxesCombined/> Result
                </div> 
                
                  <ChevronRight/> 
                
            </div>
            
               <div className={`drawer-menu-item  ${active_menu === 'house-club-activity' ? 'sidebar-active-menu' : ''}`} onClick={()=>MenuClick('house-club-activity')}>
                <div className="menu-item-super">
                    <Club/> House/Club Activity 
                </div> 
                
                  <ChevronRight/> 
                
            </div>
            <div className={`drawer-menu-item  ${active_menu === 'alert' ? 'sidebar-active-menu' : ''}`} onClick={()=>MenuClick('alert')}>
                <div className="menu-item-super">
                    <Megaphone/> Alerts 
                </div> 
                
                  <ChevronRight/> 
                
            </div>
            <div className={`drawer-menu-item  ${active_menu === 'applications' ? 'sidebar-active-menu' : ''}`} onClick={()=>MenuClick('applications')}>
                <div className="menu-item-super">
                    <FileUser/> Applications 
                </div> 
                
                  <ChevronRight/> 
                
            </div>

     <div onClick={()=>{setVisible(true)
         setSideBar(false)}} className={`drawer-menu-item  ${active_menu === 'applications' ? 'sidebar-active-menu' : ''}`} >
                <div className="menu-item-super">
                    <Download/> Install App 
                </div> 
              
                  <ChevronRight/> 
                
            </div>
      
        </div>  
    </div>
    <>
    {visible && (

        <>
 <div style={overlayStyle}>
        <div style={popupStyle}>
          <h2 style={{ marginBottom: 8 }}>Install App 🚀</h2>
          <p style={{ color: "#555", fontSize: 14 }}>
            Get faster access and a full-screen experience.
          </p>

          <div style={{ marginTop: 20 }}>
            <button style={installBtn} onClick={handleInstall}>
              Install Now
            </button>
            <button style={closeBtn} onClick={closePopup}>
              Maybe Later
            </button>
          </div>

          <label style={checkboxStyle}>
            <input
              type="checkbox"
              checked={dontShow}
              onChange={(e) => setDontShow(e.target.checked)}
            />
            Don’t show me again
          </label>
        </div>
      </div>
        </>
    )}
     
    </>
    <div onClick={()=>setSideBar(false)} className={`SideBarOverlay ${show_sidebar ? 'open_overlay' : 'close_overlay'}`}></div>
    </>)
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const popupStyle = {
  width: 320,
  background: "#fff",
  borderRadius: 16,
  padding: 20,
  textAlign: "center",
  boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
  animation: "scaleIn 0.3s ease",
};

const installBtn = {
  width: "100%",
  padding: "12px",
  borderRadius: 10,
  border: "none",
  background: "#2563eb",
  color: "#fff",
  fontSize: 16,
  cursor: "pointer",
};

const closeBtn = {
  width: "100%",
  padding: "10px",
  borderRadius: 10,
  border: "none",
  background: "#eee",
  marginTop: 10,
  cursor: "pointer",
};

const checkboxStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  fontSize: 13,
  marginTop: 14,
  color: "#444",
};

export default SideBar;